var _linearGradient, _linearGradient2, _linearGradient3, _linearGradient4, _linearGradient5, _linearGradient6, _path, _circle, _path2, _ellipse, _circle2, _circle3, _circle4, _circle5, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgColombiaRevancha(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 205 205",
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 0.968,
    y1: -0.21,
    x2: 0.324,
    y2: 0.764
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.006,
    stopColor: "#fff",
    stopOpacity: 0.75
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  }))), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: 0.969,
    y1: -0.21,
    x2: 0.326,
    y2: 0.765
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.006,
    stopColor: "#fff",
    stopOpacity: 0.75
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  }))), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    x1: 0.48,
    y1: -0.349,
    x2: 0.507,
    y2: 0.878
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.006,
    stopColor: "#fff",
    stopOpacity: 0.75
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  }))), _linearGradient4 || (_linearGradient4 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    x1: 0.34,
    y1: -0.255,
    x2: 0.572,
    y2: 0.839
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.006,
    stopColor: "#fff",
    stopOpacity: 0.75
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  }))), _linearGradient5 || (_linearGradient5 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "e",
    x1: 0.752,
    y1: -0.147,
    x2: 0.489,
    y2: 0.556
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.006,
    stopColor: "#fff",
    stopOpacity: 0.75
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  }))), _linearGradient6 || (_linearGradient6 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "f",
    x1: -0.107,
    y1: 1.092,
    x2: 0.559,
    y2: 0.444
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.006,
    stopColor: "#fff",
    stopOpacity: 0.75
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M54.352 103.619c1.219-1.97 23.635-35.171 40.423-59.931l.469-16.507c.188-7.409-5.627-13.599-13.037-13.787-7.409-.188-13.599 5.627-13.787 13.037l-.938 35.264-4.408-23.635c-1.407-7.315-8.347-12.099-15.663-10.692-7.315 1.313-12.099 8.347-10.786 15.569l13.13 69.685c1.313-3.095 2.814-6.096 4.596-9.004z",
    fill: "#6aa1d7"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 108.937,
    cy: 137.195,
    r: 24.854,
    fill: "#d85006"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M168.305 131.286c-.75-8.066-7.784-14.256-15.381-14.537 5.44-5.252 4.877-14.819-.75-20.821-9.66-10.129-22.791-16.788-37.421-18.101l27.011-40.423c4.689-7.034 2.814-16.601-4.22-21.384-7.034-4.689-16.601-2.814-21.384 4.22l-57.867 85.722a59.708 59.708 0 0 0-8.629 30.95c0 33.482 27.668 60.493 61.337 59.368 31.419-1.032 56.836-26.73 57.492-58.149.188-2.251.094-4.596-.188-6.847zm-30.2-.75c.469 2.157.75 4.408.75 6.659 0 16.507-13.412 29.918-29.918 29.918s-29.918-13.412-29.918-29.918 13.412-29.918 29.918-29.918c9.285 0 17.632 4.22 23.072 10.973 2.907 2.063 6.284 3.283 9.66 3.001.094 0-3.376 2.438-3.564 9.285z",
    fill: "#0b2a61"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    transform: "rotate(-56.121 83.594 118.737) scale(.93786)",
    cx: 98.249,
    cy: 160.023,
    rx: 11.5,
    ry: 16.3,
    fill: "#ea8a4d"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 153.393,
    cy: 131.943,
    r: 13.974,
    fill: "url(#a)"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 128.727,
    cy: 29.151,
    r: 13.974,
    fill: "url(#b)"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 81.645,
    cy: 27.275,
    r: 12.005,
    fill: "url(#c)"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 49.757,
    cy: 40.5,
    r: 12.005,
    fill: "url(#d)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M92.337 94.24c-.563 7.034 9.942 11.348 14.819 10.973 7.409-.657 17.257.469 25.979 10.598 2.157 2.532 5.534 3.845 9.191 3.845a12.81 12.81 0 0 0 12.849-12.849c0-4.877-3.939-9.848-7.409-12.755-13.13-10.692-24.854-15.475-40.048-14.819-3.283.094-14.443 3.189-15.381 15.006z",
    fill: "url(#e)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M107.53 176.492c-10.504 0-20.071-3.845-27.105-11.067-7.972-8.066-12.192-19.602-11.255-30.95.094-1.594 1.501-2.72 3.001-2.532 1.594.094 2.72 1.501 2.532 3.001-.75 9.754 2.814 19.602 9.66 26.542 4.689 4.689 12.943 10.129 25.698 9.285 1.594-.094 2.907 1.032 3.001 2.626s-1.032 2.907-2.626 3.001c-.938.094-1.876.094-2.907.094z",
    fill: "url(#f)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgColombiaRevancha);
export default __webpack_public_path__ + "static/media/colombia_revancha.3c9a4c86a76d9fb1e8c016ccb09f6ecb.svg";
export { ForwardRef as ReactComponent };